import { useLocation } from 'react-router-dom';

/** Custom hook to identify Parent Route Name */
const useRouteLocation = (matchToRoute: string): { isMatched: boolean; parentRoute: string; } => {
  const location = useLocation();
  const parentRoute = location.pathname.split('/')[1] || '';
  const isMatched = parentRoute === matchToRoute;

  return { isMatched, parentRoute };
};

export default useRouteLocation;
